import React, { useEffect } from 'react';
import { Box, Button, Stack, Typography, useTheme, TextField } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getSingleProdServ, updateProdStock } from '../../../services/amtc-service';
import { isNotEmpty } from '../../../utils/format';
import BgBoxOld from '../../../components/BgBoxOld';
import route from '../../../utils/Routes';
import { customAlert, notify } from '../../../components/notify';

function UpdateProdStockDtls() {
    const theme = useTheme();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const location = useLocation();
    const { prodId } = location.state || {};
    const { setLoadingScreen } = useAuthContext();
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amtcProdInfo, prodId, "amtc"], () => getSingleProdServ(prodId, "amtc"),
        {
            enabled: isNotEmpty(prodId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })

    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!prodId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prodId])

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        setLoadingScreen(true);
        try {
            const payload = {
                avlQty: isNotEmpty(inputObject.avlQty) ? inputObject.avlQty : 0,
                amtcPrice: isNotEmpty(inputObject.amtcPrice) ? inputObject.amtcPrice : 0,
                amtcTax: isNotEmpty(inputObject.amtcTax) ? inputObject.amtcTax : 0,
            }
            const { message } = await updateProdStock(payload, prodId);
            notify("success", message);
            queryClient.invalidateQueries([QueryKey.amtcProdInfo, prodId, "amtc"]);
            navigate(`${route.aProduct}/?prodId=${prodId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function handleCancel() {
        navigate(`${route.aProduct}/?prodId=${prodId}`, { replace: true });
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
        <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
            <BackButton width={"20%"} />
            <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                <Typography width={"33.3%"} sx={{ fontSize: 18, fontWeight: 500 }}>Update Stock Details</Typography>
            </Stack>
            <Box width={"20%"} />
        </Stack>
        <BgBoxOld height={"93%"} py={1}>
            {prodData && <Stack >
                <LabelTxtFieldInfo defaultValue={prodData?.prodName} name="prodName" title="Product Name"
                    width={300} height={25} borderRadius={1} bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true} />
                <Box height={10} />
                <LabelTxtFieldInfo defaultValue={prodData?.amtcProdIdStrg} bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true}
                    name="amtcProdIdStrg" title="Amtc Product ID" width={300} height={25} borderRadius={1} />

                <Stack mt={3} width={300} gap={2}>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                        <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                            Product Quantity <Typography fontSize={10} component="span" variant="caption" >(Nos)</Typography>
                        </Typography>
                        <TextField defaultValue={prodData?.avlQty} name='avlQty' type='number' size='small'
                            sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }}
                        // onKeyDown={(e) => {
                        //     // Prevent decimal and exponential
                        //     if (["e", "E", ".", "+", "-"].includes(e.key)) {
                        //         e.preventDefault();
                        //     }
                        // }} 

                        />
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                        <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                            Price <Typography component="span" fontSize={10} variant="caption">(OMR)</Typography>
                        </Typography>
                        <TextField defaultValue={prodData?.amtcPrice} name='amtcPrice' type='number' size='small'
                            sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                        <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                            Tax <Typography component="span" fontSize={10} variant="caption">(in %)</Typography>
                        </Typography>
                        <TextField defaultValue={prodData?.amtcTax} name='amtcTax' type='number' size='small'
                            sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                    </Stack>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} sx={{ width: "50%", justifyContent: "end", mt: 5 }} >
                    <Button variant="outlined" onClick={handleCancel} sx={{
                        fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                        color: theme.palette.custom.btn, mr: 2,
                    }}>CANCEL</Button>
                    <Button variant="contained" type="submit"
                        sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", mr: 10 }}>
                        SAVE</Button>
                </Stack>
            </Stack>}
        </BgBoxOld>
    </form>);
}

export default UpdateProdStockDtls;